const invoicePage = [
  // Hiding this page because no client use it, will add back if required
  // {
  //   path: '/v2/payIndents',
  //   name: 'Pay Indents',
  //   component: () => import('@/components/modules/payIndents/index'),
  //   meta: {
  //     title: 'Indents',
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/v2/invoice',
    name: 'Invoices',
    component: () => import('@/components/modules/invoices-v2/index'),
    meta: {
      title: 'Invoices',
      requiresAuth: true,
    },
  },
  {
    path: '/v2/invoices/:id',
    name: 'invoiceDetails',
    component: () => import('@/components/modules/invoices-v2/invoiceDetails'),
    meta: {
      title: 'Invoices',
      requiresAuth: true,
    },
  },
  {
    path: '/v2/wallet',
    name: 'Wallet-v2',
    component: () => import('@/components/modules/wallet-v2/index'),
    meta: {
      title: 'Wallet',
      requiresAuth: true,
    },
  },
];

export default invoicePage;
